module.exports = __webpack_public_path__ + "static/media/restore_white.ff27e266.svg";